import {React,useState,useEffect} from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {InputAdornment, MenuItem } from '@material-ui/core';
import paymentMethods from "./paymentMethods";
import { makeStyles } from '@material-ui/core/styles';

export default function PaymentFormDialog(props) {
const {open,callback,invoiceNo,amount,paymentType,security}=props;
const [paymentMethod,setPaymentMethod]=useState("");
const [paymentMethodValid,setPaymentMethodValid]=useState(true);
const [paymentReference,setPaymentReference]=useState("");
const [paymentReferenceValid,setPaymentReferenceValid]=useState(true);
const [referenceName,setReferenceName]=useState("");
const [paidTo,setPaidTo]=useState("");
const [paidToHelper,setPaidToHelper]=useState("");

  const handleCancel = () => {
    callback(null)
  };

  const handleSave = () => {
    if (!validateReference()){return;}
    const currentPaymentMethod=paymentMethods.find(({ key }) => key === paymentMethod )
    const zohoMethod=currentPaymentMethod.zohoValue;
    const incomeAccount=currentPaymentMethod.incomeValue;
    const zohoReference=(paymentMethod==="JCC"||paymentMethod==="stripe")?paymentReference:incomeAccount;
    callback({"invoice_no":invoiceNo,"zohoMethod":zohoMethod,"zohoReference":zohoReference,"incomeAccount":incomeAccount,"amount":amount})
  };

  const validateReference=()=>{
    if(paymentType==="jccpayment" || paymentType==="stripepayment"){
      if(paymentReference===""){
        setPaymentReferenceValid(false);
        return false;
      }
    }else{
      if(paymentMethod===""){
        setPaymentMethodValid(false);
        return false;
      }
    }
    setPaymentReferenceValid(true);
    setPaymentMethodValid(true);
    return true;
  }

  const paymentMethodChanged=(event)=>{
    setPaymentMethodValid(true);
    setPaymentReferenceValid(true);
    setPaymentMethod(event.target.value);
  }
  const paymentReferenceChanged=(event)=>{
    setPaymentMethodValid(true);
    setPaymentReferenceValid(true);
    setPaymentReference(event.target.value);
  }

useEffect(()=>{
  //validateReference();
},[paymentReference,paymentMethod])

  useEffect(()=>{
    if(!open){
      setPaymentReference("");
    }else{
      setPaymentMethod("");
      setPaidTo("Paid to");
      setPaidToHelper("Please select who received the money");
      if(paymentType==="jccpayment"){
        setPaymentMethod("JCC");
        setReferenceName("JCC");
        setPaidTo("Payment method");
        setPaidToHelper("");
        setPaymentMethodValid(true);
      }else if(paymentType==="stripepayment"){
        setPaymentMethod("stripe");
        setReferenceName("Stripe");
        setPaidTo("Payment method");
        setPaidToHelper("");
        setPaymentMethodValid(true);
      }
    }
  },[open])
  const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
      },
    },
  }));
  const classes = useStyles();
  return (
    <div>
      <Dialog open={open} onClose={handleCancel} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Pay invoice {invoiceNo}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Register a payment received
          </DialogContentText>
          <form className={classes.root} noValidate autoComplete="off">
          <TextField
          id="selectpaymentmethod"
          select
          label={paidTo}
          error={!paymentMethodValid}
          onChange={paymentMethodChanged}
          helperText={paidToHelper}
          value={paymentMethod}
          fullWidth
        >
          {paymentMethods.map((method,index)=>{
              if(paymentType==="cashpayment"){
                  if(!security.add_all_cashpayment){
                    if(security.add_own_cashpayment && security.own===method.incomeValue){
                      
                    }else{
                      return false;
                    }
                  }
              }
              return (method.type===paymentType)&&<MenuItem key={method.key} value={method.key}>{method.incomeValue}</MenuItem>
          })}
          
          
          
        </TextField>
        
        {(paymentType==="jccpayment" || paymentType==="stripepayment")&&<TextField
            id="ref"
            label={referenceName+" Reference"}
            helperText={"Enter reference provided by "+referenceName}
            error={!paymentReferenceValid}
            fullWidth
            required
            onChange={paymentReferenceChanged}
            autoFocus
          />
  }
        
          <TextField
            margin="normal"
            id="amount"
            label="Amount"
            type="number"
            fullWidth
            value={amount.toFixed(2)}
            InputProps={{
              readOnly: true,
              startAdornment: (
                <InputAdornment position="start">
                  €
                </InputAdornment>
              ),
            }}
          />
          </form> 
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} size="medium" variant="text" color="primary">Cancel</Button>
          <Button onClick={handleSave} size="medium"  variant="text" color="primary">Save Payment</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
